import { AxiosResponse, AxiosInstance, AxiosError } from 'axios';
import {
  ZipCode,
  ServiceNotReached,
  IncorrectZipCode,
  ZipCodeError,
  ZipCodeErrorEnum,
} from 'interfaces/ZipCode';
import { axiosInstance } from '../Requests';

export default class ZipCodeService {
  private axiosInstance: AxiosInstance;

  constructor() {
    this.axiosInstance = axiosInstance;
  }

  checkZipCode(
    zipCode: string,
    houseNumber: string,
  ): Promise<ZipCodeError | ServiceNotReached | ZipCode> {
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    return this.axiosInstance.get(`utils/addresses/${zipCode.replace(' ', '')}/${houseNumber}`)
      .then((r: AxiosResponse<ZipCode>) => r.data)
      .catch((
        r: AxiosError<IncorrectZipCode | ServiceNotReached>,
      ): undefined | ServiceNotReached => {
        const {
          response,
        } = r;

        if (response?.status === 503) {
          return {
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-ignore
            code: ZipCodeErrorEnum.ZIP_CODE_ADDRESS_NOT_FOUND,
          };
        }

        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        const data = response?.data;

        if (data && 'errors' in data) {
          return data.errors[0];
        }

        return data;
      });
  }
}
